import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import AddProductForm from "../components/AddProductForm";
import DefaultTopBar from "../components/DefaultTopBar";

const AddProductPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        <DefaultTopBar
            title="Create a New Product"
        />

        {/* TableDataLayer */}
        <AddProductForm />

      </MasterLayout>

    </>
  );
};

export default AddProductPage; 
